(function (Drupal, $) {
  'use strict';

  Drupal.behaviors.acg_event_filters = {
    attach: function (context, settings) {

      // Initialize jQuery UI Datepicker manually.
      // This didn't used to be needed pre-D9.
      $(context).find('.filter-item--date-range').once('datepickers').each(function() {
        var $dateRangeWrapper = $(this);

        $dateRangeWrapper.find('input').each(function() {
          var $thisDateInput = $(this);
          $thisDateInput.datepicker();
        });
      });

      // Add our behaviors on the additional filters element
      // First, implement our code only once on the page for our show filters button
      $(context).find('#showFilters').once('acg_event_filters_additional').each(function () {
        // Add the event handler on the button
        $(this).click(function () {
          // Toggle the class on the button
          var $self = $(this);
          $self.toggleClass('open');
          // Get the additional filters element
          // @todo: make this work with multiple instances
          var $additionalFilters = $('#additionalFilters');
          // slide toggle on the filters
          $additionalFilters.slideToggle('fast');
        });
      });

      // add behavior for Event Type fieldset dropdown element.
      $(context).find('.filter-checkboxes .form-wrapper legend').once('acg_event_fieldset_dropdown').each(function () {
        $(this).click(function () {
          var $self = $(this);
          // Toggle the class on the button
          $self.toggleClass('open');
          var $fieldsetWrapper = $self.parent().find('.fieldset-wrapper');
          // slide toggle on the fieldset wrapper element
          $fieldsetWrapper.slideToggle('fast');
        });
      });

    }
  };
})(Drupal, jQuery);
